import React from "react";
import { useNavigate } from "react-router-dom";
import { serverUrl } from "../../config";
import GridItem from "../../partials/gridItem";

export default function FormItem(props) {
  const navigate = useNavigate();
  if (props.creator) {
    return (
      <GridItem
        xs={12}
        sm={6}
        lg={3}
        xl={3}
        xxl={2}
        itemClass="form"
        item={props.item}
        bundle={props.item?.bundle}
        id={props.item?.id || props.item?.id}
        title={props.item?.title}
        // field_body={
        //   props.item?.summary ? props.item?.summary : props.item?.body
        // }
        category_label={props.item?.category_labels}
        created={props.item?.created}
        hasImg={true}
        imgSrc={`${serverUrl}/${props.item.field_featured_image}`}
        cardActionArea={true}
        creator={props.creator}
        contentType={props.contentType}
        shareEnabled
        route={"forms"}
        field_access_token={props.item.field_access_token}
        sharePrompt={`This is a public link that enables you to share the form with your client, no login required.`}
      />
    );
  } else
    return (
      <GridItem
        xs={12}
        sm={6}
        md={3}
        itemClass="form"
        bundle={props.item?.bundle}
        nid={props.item?.id ?? props.item?.nid}
        cardActionArea={true}
        hasImg={true}
        imgSrc={`${serverUrl}/${props.item.field_featured_image}`}
        title={props.item?.title}
        field_body={
          props.item?.summary ?? ""
        }
        category_label={props.item?.category_labels}
        created={props.item?.created}
        cardActionCallBack={() =>
          navigate(`/forms/view/${props.item?.id ?? props.item?.nid}`)
        }
        contentType={props.contentType}
      />
    );
}
